import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SocketProvider } from '../../providers/socket/socket';

@Component({
  selector: 'page-room',
  templateUrl: 'room.html',
  // providers:[SocketProvider]
})
export class RoomPage {
  roomNumber;
  name;
  background;
  constructor(public navCtrl: NavController, public navParams: NavParams, private socketProvider:SocketProvider) {
    this.roomNumber = this.socketProvider.roomNumber;
    this.socketProvider.sendMessage({
      action:"list"
    });
    this.name = this.socketProvider.name;
    this.background = '../../assets/imgs/background/' + this.socketProvider.getRandomBackground();
  }

  startGame() {
    this.socketProvider.sendMessage({
      action: "start"
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/room/room.ts